import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/area-picker-arrow.svg'


import { ElInput, ElPopover } from "element-plus"
import { createAreaContext } from "./context";
import { computed, ref } from "vue";
import PickerPanel from "./panel/area-picker-panel.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'area-picker',
  emits: ['confirm'],
  setup(__props, { expose: __expose, emit: __emit }) {

const { model } = createAreaContext()
const emit = __emit

const pickerPanel = ref();

const popoverVisible = ref(false)
const currentCity = ref('全国')

const inputValue = computed(() => {
  if (!model.city && !model.province) return '全国'

  return [model.province?.districtName, model.city?.districtName].filter(Boolean).join('/')
})

const onConfirm = () => {
  onCancel()
  console.log(inputValue.value, 'inputValue')
  currentCity.value = model.city?.districtName
  emit('confirm', currentCity.value)

}

const onCancel = () => {
  popoverVisible.value = false
}

const onClear = () => {
  currentCity.value = '全国'
}

const reset = () => {
  model.province = undefined;
  model.city = undefined
  pickerPanel.value?.reset()
  onClear()
}

__expose({ reset })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElPopover), {
    visible: popoverVisible.value,
    width: "520px",
    placement: "bottom-start"
  }, {
    reference: _withCtx(() => [
      _createVNode(_unref(ElInput), {
        readonly: "",
        value: currentCity.value,
        class: "area-picker",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (popoverVisible.value = !popoverVisible.value)),
        clearable: "",
        onClear: onClear
      }, {
        suffix: _withCtx(() => [
          _createElementVNode("img", {
            style: _normalizeStyle({ transition: 'all 0.2s', transform: popoverVisible.value ? 'rotate(0deg)' : 'rotate(180deg)' }),
            src: _imports_0
          }, null, 4)
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    default: _withCtx(() => [
      _createVNode(PickerPanel, {
        onConfirm: onConfirm,
        onCancel: onCancel,
        ref_key: "pickerPanel",
        ref: pickerPanel
      }, null, 512)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})